<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                เครดิตคงเหลือของสมาชิก
                </div>


                <div class="row search-section">
                    <div class="col-sm-6 col-search">


                    </div>
                   
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อสมาชิก เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    
                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>
              
                <div class="body table-responsive" style="width:100%">
                       <div class="row">
                            <div class="col-sm-6" style="text-align: left;">
                                <div class="p-title">จำนวนเครดิตทั้งหมด: {{ total_amount | comma }} บาท</div>
                            </div>
                            <div class="col-sm-5"> </div>
                            <div class="col-sm-1" style="text-align: right;"> 
                                <!-- <img src="static/images/excel.png" style="position: absolute;right: 10px;cursor: pointer;" @click="download()"/> -->
                            </div>
                        </div>
                      <div class="row" style="margin-top: 10px;">
                            <div class="col-sm-12" style="text-align: left;">
                                <div class="p-title" style="color: red;">*** หากไม่ต้องการนับเครดิตของสมาชิก กรุณาตั้งค่ายกเว้น</div>
                            </div>
                        </div>
                        

                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else style="margin-top: 15px;">


                        <table class="table table-bordered">
                            <thead>
                               
                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    <th class="fn-th">Username</th>
                                    <th class="fn-th">ชื่อสมาชิก</th>
                                    <th class="fn-th">ยกเว้น</th>
                                    <th class="fn-th">จำนวนเครดิตคงเหลือ</th>
                                    <th class="fn-th" style="width: 80px;">ตั้งค่า</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page-1) * perpage) + index + 1"></td>
                            

                                    <td style="text-align: center;">
                                        <span>{{ item.username }}</span>
                                    </td>
                                    <td style="text-align: left;margin-left: 15px;">
                                        <span>{{ item.name }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <i class="material-icons" v-if="item.exception == 1" style="color: green;font-size: 20px;">done</i>
                                    </td>
                                    <td style="text-align: right;padding-right: 15px;">
                                        <span>{{ item.credit | comma }}</span>
                                    </td>
                                     <td>
                                        <span @click="edit(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">settings</i>
                                            </a>
                                        </span>
                                    </td>
                                    
                                
                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>
        
         <div class="modal fade" id="member-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">แก้ไขสมาชิก</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>username:</span>
                        </div>
                        <div class="col-sm-8" style="margin-top: 5px;text-align: left;">
                           <div>{{ member.username }}</div>
                            
                        </div>
                    </div>
              
            
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                          
                        </div>
                        <div class="col-sm-8" style="margin-top: 5px;text-align: left;">
                           
                          <input type="checkbox" id="checkbox-user" @click="exception = !exception" class="filled-in chk-col-indigo" :checked="exception"/>
                            <label for="checkbox-user" >ยกเว้น</label>
                        </div>
                    </div>
                    
                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import MemberService from '../../service/MemberService'
import helper from '../../classes/helper'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "CreditLog",
    components: {
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            date:localStorage.getItem('date'),
            page: 1,
            perpage: 50,
            total: 0,
            total_amount: 0,
            pages: 0,
            items: [],
            member: {},
            exception: false,
            key: "",
            searching: false,
            loading: false
        }
    },
    async created() {
         this.start_date =  new Date(this.date)
        this.end_date =  new Date(this.date)
        this.search(1)
    },
    mounted() {

    },
    methods: {

        async search(p = 0) {
             if (p > 0) {
                this.page = p
            }
            this.loading = true
         
            let response = await MemberService.searchCredit(this.key, this.page, this.perpage)
         
            if (response.status) {
                let { page, perpage, total, pages, data ,total_amount} = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data
                this.total_amount = Number(total_amount)

            }
            this.loading = false
        },
         edit(id) {
          
            let member = this.items.find(x => x.id == id)
            this.member = { ...member, updated_by: this.user.id }
            this.exception = member.exception == 1 ? true : false
            console.log(this.member)
            console.log(this.exception)
            $('#member-modal').modal('show')
        },
         async handleSave() {
            try {
                let exception = this.exception ? 1 : 0
                let response = await MemberService.updateException(this.member.id, exception)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.member = {}
                    this.exception = false
                    this.search(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
                  $('#member-modal').modal('hide')
            }
            catch (error) {
                alertBox.error("Error, " + error)
                  $('#member-modal').modal('hide')
            }
        },
    },
    filters: {
        comma(value) {
            return helper.WithComma(value,2)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>

   
</style>


// WEBPACK FOOTER //
// src/components/Manage/CreditLog.vue